import type { Prototype } from "../prototype-types";

export const jocelynTeresPrototypes: Prototype[] = [
  {
    id: "fd-website-setup-wizard",
    name: "FD Website Setup Wizard",
    path: "/jt/fd-website-setup-wizard",
    description:
      "Step-by-step wizard for setting up a Faire Direct website with branding, features, and configuration options.",
    owner: "Jocelyn",
    createdAt: "2026-01-09",
    lastUpdated: "2026-01-09",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f726f271999f1ba32c4b59a644f40a9fe97eecdfa5c7d5247ff34360b3dbc088.png",
    creationTool: "cursor",
  },
];
